import { isMobileAtom } from '@/jotai/atoms/userAtom';
import {
  Button,
  message,
  Modal,
  Popconfirm,
  Space,
  Table,
  TableColumnType,
} from 'antd';
import { useAtomValue } from 'jotai';
import {
  commentDelete,
  commentViolation,
  ExhibitionCommentDTO,
  ExhibitionCommentQueryDTO,
  getExhibitionCommentList,
} from '@/api/exhibition';
import { FORMAT_TIME } from '@/types/common';
import dayjs from 'dayjs';
import { useRequest } from 'ahooks';
import { LeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

enum violationStatusEnum {
  normal,
  violation
}

const ExhibitionPage = () => {
  const isMobile = useAtomValue(isMobileAtom);
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const pageSize = isMobile ? 10 : 20;

  const { data: exhibitionList, loading, refresh, run } = useRequest(async (page = 1) => {
    const params: ExhibitionCommentQueryDTO = {
      currentPage: page,
      pageSize,
      deleteStatus: 0
    };
    const resp = await getExhibitionCommentList(params);

    if (resp.status === 200 && resp.data.success) {
      return resp.data.data;
    }

    return {
      records: [],
      total: 0,
      currentPage: page,
      pageSize,
    };
  });

  const onExpandContent = (content: string) => {
    Modal.info({
      title: "评价内容",
      content
    });
  }

  const columns: TableColumnType<ExhibitionCommentDTO>[] = [
    {
      title: '时间',
      dataIndex: 'createTime',
      key: 'time',
      render: (_) => dayjs(_).format(FORMAT_TIME),
    },
    {
      title: '所属Events',
      dataIndex: 'exhibitionTitle',
      key: 'exhibitionTitle',
    },
    {
      title: '打分',
      dataIndex: 'score',
      key: 'score',
    },
    {
      title: '评价内容',
      dataIndex: 'content',
      key: 'content',
      width: "100px",
      render: (_) => {
        if (!_) return "";
        const num = 50;
        const isHid = _.length > num;
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <div>{`${_.slice(0, num)}${isHid ? '...' : ''}`}</div>
            {
              isHid && <Button type="link" onClick={() => onExpandContent(_)}>展开</Button>
            }
          </div>
        )
      }
    },
    {
      title: '用户信息',
      dataIndex: 'userId',
      key: 'user',
      render: (_, record) => {
        return (
          <div>
            <div>ID: {_}</div>
            <div>{record.userName}</div>
          </div>
        )
      }
    },
    {
      title: '操作',
      key: '操作',
      width: 100,
      fixed: 'right',
      render: (_, record) => (
        <Space size="small" direction="vertical">
          <Popconfirm
            title="删除评论"
            description="确定删除该评论吗？"
            onConfirm={() => onDelete(record.id)}
          >
            <Button
              type="link"
              size="small"
            >
              删除
            </Button>
          </Popconfirm>

          {record.violationStatus === violationStatusEnum.normal && (
            <Popconfirm
              title="确认违规"
              description="确定要将该评论修改为违规吗？"
              onConfirm={() =>
                onChangeStatus(record.id, violationStatusEnum.violation)
              }
            >
              <Button
                type="link"
                size="small"
              >
                确认违规
              </Button>
            </Popconfirm>
          )}
          {
            record.violationStatus === violationStatusEnum.violation && (
              <Popconfirm
                title="恢复正常"
                description="确定要将该评论恢复正常吗？"
                onConfirm={() =>
                  onChangeStatus(record.id, violationStatusEnum.normal)
                }
              >
                <Button
                  type="link"
                  size="small"
                  danger
                >
                  恢复正常
                </Button>
              </Popconfirm>
            )}
        </Space>
      ),
    },
  ];

  const onChangeStatus = async (id: number, status: violationStatusEnum) => {
    const res = await commentViolation({
      id,
      violationStatus: status
    })

    if (res.status !== 200) {
      messageApi.error('修改失败');
      return;
    }
    messageApi.success('修改成功');
    refresh();
  };

  const onDelete = async (id: number) => {
    const res = await commentDelete({
      id
    })

    if (res.status !== 200) {
      messageApi.error('删除失败');
      return;
    }
    messageApi.success('删除成功');
    refresh();
  };

  return (
    <div className="report-container">
      {contextHolder}
      <Space style={{ marginBottom: 24 }}>
        <Button onClick={() => navigate(-1)} icon={<LeftOutlined />} />
      </Space>
      <Table
        size="small"
        loading={loading}
        columns={columns}
        dataSource={exhibitionList?.records}
        rowKey="id"
        scroll={{ x: 'max-content' }}
        pagination={{
          size: isMobile ? 'small' : 'default',
          pageSize,
          showSizeChanger: false,
          total: exhibitionList?.total,
          current: exhibitionList?.currentPage,
          onChange: (page) => run(page),
        }}
      />
    </div>
  );
};

export default ExhibitionPage;
